// document.addEventListener('DOMContentLoaded', function() {
//     const searchInput = document.getElementById('variantSearch');
//     const rows = document.querySelectorAll('.variant-row');

//     function filterTable(value) {
//         value = value.toLowerCase();
//         rows.forEach(row => {
//             row.style.display = row.dataset.search.includes(value) ? '' : 'none';
//         });
//     }
//     searchInput.addEventListener('keyup', e => {
//         filterTable(e.target.value);
//     });

//     document.querySelectorAll('.bo_swatch').forEach(swatch => {
//         swatch.addEventListener('click', () => {
//             const value = swatch.dataset.search;
//             searchInput.value = value;
//             filterTable(value);
//         });
//     });

//     const clearBtn = document.getElementById('clearFilters');
//     if (clearBtn) {
//         clearBtn.addEventListener('click', () => {
//             searchInput.value = '';
//             rows.forEach(row => row.style.display = '');
//         });
//     }

//     // Add to Cart buttons
//     document.querySelectorAll('.add-to-cart').forEach(btn => {
//         btn.addEventListener('click', async () => {
//             const variantId = btn.dataset.id;
//             const row = btn.closest('tr');
//             const qtyInput = row.querySelector('input[type="number"]');
//             const quantity = qtyInput ? parseInt(qtyInput.value) : 1;

//             if (!variantId || quantity < 1) return;

//             try {
//                 await fetch('/cart/add.js', {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         id: variantId,
//                         quantity: quantity
//                     })
//                 });

//                 // console.log('Product added to cart:', variantId, 'Qty:', quantity);
//                 refreshCartDrawer();

//             } catch (err) {
//                 console.error('Add to cart failed', err);
//             }
//         });
//     });

// });


// document.addEventListener('DOMContentLoaded', function () {
//   const searchInput = document.getElementById('variantSearch');
//   const items = document.querySelectorAll(
//     '.variant-row, .bulk-order.mobile .inner-grid'
//   );
//   function filterItems(value) {
//     value = value.toLowerCase();
//     items.forEach(item => {
//       const search = item.dataset.search || '';
//       item.style.display = search.includes(value) ? '' : 'none';
//     });
//   }
//   if (searchInput) {
//     searchInput.addEventListener('keyup', e => {
//       filterItems(e.target.value);
//     });
//   }
//   document.querySelectorAll('.bo_swatch').forEach(swatch => {
//     swatch.addEventListener('click', () => {
//       const value = swatch.dataset.search || '';
//       if (searchInput) searchInput.value = value;
//       filterItems(value);
//     });
//   });
//   const clearBtn = document.getElementById('clearFilters');
//   if (clearBtn) {
//     clearBtn.addEventListener('click', () => {
//       if (searchInput) searchInput.value = '';
//       items.forEach(item => item.style.display = '');
//     });
//   }
//   // document.querySelectorAll('.add-to-cart').forEach(btn => {
//   //   btn.addEventListener('click', async () => {
//   //     const variantId = btn.dataset.id;
//   //     if (!variantId) return;
//   //     const container = btn.closest('tr, .inner-grid');
//   //     const qtyInput = container?.querySelector('input[type="number"]');
//   //     const quantity = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
//   //     try {
//   //       await fetch('/cart/add.js', {
//   //         method: 'POST',
//   //         headers: { 'Content-Type': 'application/json' },
//   //         body: JSON.stringify({
//   //           id: variantId,
//   //           quantity: quantity
//   //         })
//   //       });
//   //       refreshCartDrawer();
//   //     } catch (err) {
//   //       console.error('Add to cart failed', err);
//   //     }
//   //   });
//   // });
// });

// // active js
// document.querySelectorAll('.swatch-wrapper .bo_swatch').forEach(function(item) {
//   item.addEventListener('click', function () {
//     this.parentElement.querySelectorAll('.bo_swatch').forEach(function(sibling) {
//       sibling.classList.remove('active');
//     });
//     this.classList.add('active');
//   });
// });
// // active js



document.addEventListener('DOMContentLoaded', function () {
  const searchInput = document.getElementById('variantSearch');
  const items = document.querySelectorAll('.variant-row, .bulk-order.mobile .inner-grid');
  const clearBtn = document.getElementById('clearFilters');

  // Hide clear button by default
  if (clearBtn) clearBtn.style.display = 'none';

  function updateClearButtonVisibility(value) {
    if (!clearBtn) return;
    clearBtn.style.display = value ? 'inline-block' : 'none';
  }

  function filterItems(value) {
    value = value.toLowerCase();
    items.forEach(item => {
      const search = item.dataset.search || '';
      item.style.display = search.includes(value) ? '' : 'none';
    });
    updateClearButtonVisibility(value);
  }

  if (searchInput) {
    searchInput.addEventListener('keyup', e => {
      filterItems(e.target.value);
    });
  }

  document.querySelectorAll('.bo_swatch').forEach(swatch => {
    swatch.addEventListener('click', () => {
      const value = swatch.dataset.search || '';
      if (searchInput) searchInput.value = value;
      filterItems(value);

      // Active class toggle
      swatch.parentElement.querySelectorAll('.bo_swatch').forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');
    });
  });

  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      // Clear input
      if (searchInput) searchInput.value = '';

      // Show all items
      items.forEach(item => item.style.display = '');

      // Hide clear button
      clearBtn.style.display = 'none';

      // Remove active from all swatches
      document.querySelectorAll('.bo_swatch').forEach(s => s.classList.remove('active'));
    });
  }
});
